/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';

import Image from 'components/Image.jsx';
import {TYPES} from 'entities/Activity'; // eslint-disable-line
import type {ActivityTypeType} from 'entities/Activity'; // eslint-disable-line

import './styles/ActivityAnnouncementTypePicker.scss';

export const TYPE_TO_IMG = {
  [TYPES.FIELD_TRIP]: require('assets/images/payments/activity_creation_field_trip.svg'),
  [TYPES.FUNDRAISER]: require('assets/images/payments/activity_creation_fundraiser.svg'),
  [TYPES.EVENT]: require('assets/images/payments/activity_creation_event.svg'),
  [TYPES.ORDER]: require('assets/images/payments/activity_creation_sale.svg'),
};

const SELECTED_CX = 'ActivityAnnouncementTypePicker-selected';

type Props = {
  type: ?ActivityTypeType,
  onSelect: () => void,
}

class ActivityAnnouncementTypePicker extends React.Component {
  props: Props;

  renderType(type: ActivityTypeType, text: string) {
    return (
      <div
        data-test={`activity-announcement-type-picker-${type}`}
        className={cx({ [SELECTED_CX]: this.props.type === type })}
        onClick={() => this.props.onSelect({ type })}>
        <Image
          className="ActivityAnnouncementTypePicker-img"
          src={TYPE_TO_IMG[type]}
        />
        <div>{text}</div>
      </div>
    );
  }

  render() {
    return (
      <div className="ActivityAnnouncementTypePicker">
        {this.renderType(TYPES.FIELD_TRIP, 'Field trip')}
        {this.renderType(TYPES.FUNDRAISER, 'Fundraiser')}
        {this.renderType(TYPES.EVENT, 'Event')}
        {this.renderType(TYPES.ORDER, 'Item sales')}
      </div>
    );
  }
}

export default ActivityAnnouncementTypePicker;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityAnnouncementTypePicker.jsx